import { render, staticRenderFns } from "./FollowUnfollowStratRenderer.vue?vue&type=template&id=1ad4dfe8&"
import script from "./FollowUnfollowStratRenderer.vue?vue&type=script&lang=js&"
export * from "./FollowUnfollowStratRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports